import { combineReducers } from "redux";
import { routerReducer} from "react-router-redux";
import auth from './auth';
import keys from "./keys";
import dashboard from "./dashboard";
import users from "./users";
import machines from "./machines"
import orders from "./orders"
import statistics from "./statistics"
import organizations from "./organizations"
import reports from "./reports"
import logs from "./logs"

const rootReducer = combineReducers({
    routing: routerReducer,
    auth,
    keys,
    dashboard,
    users,
    machines,
    orders,
    statistics,
    organizations,
    reports,
    logs,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js